import ComingSoonBody from "@/components/landing/auth/ComingSoonBody";

export default function ComingSoonPage() {
  return <ComingSoonBody />;
}
